import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/_home": [5],
		"/aa-offer": [6],
		"/app-choice": [7],
		"/assessment-purchase": [8],
		"/cancel-subscription": [9,[2]],
		"/cancel-subscription/assessment-center": [10,[2]],
		"/cancel-subscription/cancel-feedback": [11,[2]],
		"/cancel-subscription/confirmation": [12,[2]],
		"/cancel-subscription/pause": [13,[2]],
		"/cancel-subscription/pause/manage": [14,[2]],
		"/cancel-subscription/pause/success": [15,[2]],
		"/cancel-subscription/save-offer": [16,[2]],
		"/cancel-subscription/success": [17,[2]],
		"/claimed-offer": [18],
		"/debug/experiment-assign": [19],
		"/desktop-choice": [20],
		"/download-app": [21],
		"/email-preferences": [22],
		"/expired": [23],
		"/forgot-password": [24],
		"/get-started": [25],
		"/giveaway/family-vacation-2026": [26],
		"/inbound-gateway": [27],
		"/inside-pw": [28],
		"/link-entry": [29],
		"/login-account-selection": [32],
		"/login-expired-link": [33],
		"/login-redeemed-link": [34],
		"/login-same-device-success": [35],
		"/login-secondary-device-success": [36],
		"/login": [30],
		"/login/too-many-attempts": [31],
		"/logout": [37],
		"/magic-link-pending": [38],
		"/parent-section": [39,[3]],
		"/parent-section/assessment-center": [40,[3]],
		"/parent-section/membership": [41,[3]],
		"/parent-section/membership/billing": [42,[3]],
		"/parent-section/membership/payment": [43,[3]],
		"/password-reset-success": [45],
		"/password-reset": [44],
		"/premium": [46],
		"/printables": [47],
		"/prospect-register": [48],
		"/purchase-gift": [49],
		"/qr-entry": [50],
		"/reactivation": [51],
		"/redeem": [52],
		"/reset-link-expired": [53],
		"/starter-pack": [54],
		"/subscription-consume": [57],
		"/subscription": [55],
		"/subscription/offer/[offer_hash]": [56],
		"/support-chatbot": [58],
		"/terminate": [59],
		"/tutor-offer": [60],
		"/universal/magic-link-redeem": [61],
		"/unsupported-browser": [62],
		"/upgrade": [63]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,

	reroute: (() => {})
};

export { default as root } from '../root.svelte';